// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--nwvZr","inner":"inner--G6Qdv","picture":"picture--s7CpN","image":"image--OY1OC"};